<template>
  <div>
    <CollegeView01 />
    <ForLink class="mt20 mb20" ref="forLink" :queryRang="3" />
  </div>
</template>

<script>
import CollegeView01 from "@/components/statistical/college/CollegeView01";
import ForLink from "@/components/statistical/ForLink";

export default {
  name: "College",
  components: {
    CollegeView01,
    ForLink
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
